(function() {
    'use strict';
    angular.module('approot',['app','appback']);
})();
(function() {
    'use strict';
    angular.module('appback',['ui.calendar','mrImage','dndLists','chieffancypants.loadingBar','angular.filter','ngSanitize','ngFileUpload','ui.bootstrap','iso.directives','uiGmapgoogle-maps']).config(function($httpProvider,cfpLoadingBarProvider,uiGmapGoogleMapApiProvider) {
   		// $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
    	$httpProvider.defaults.headers.post['X-CSRF-Token'] = jQuery('meta[name="csrf-token"]').attr("content");
 	    $httpProvider.defaults.timeout = 30000;
         uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyCOzsaiNUMtWf-MBDqaWTOFBXE-EIVnzpc',  // 🔹 Reemplaza con tu API Key de Google Maps
            v: '3',  // Versión de Google Maps
            libraries: 'places,geometry'  // Librerías opcionales
        });
	}).config(["$interpolateProvider",function($interpolateProvider){
        $interpolateProvider.startSymbol("[[");
        $interpolateProvider.endSymbol("]]");
    }])


})();
 